export enum QueryKey {
  getOffers = 'getOffers',
  getRefunds = 'getRefunds',
  getInvoices = 'getInvoices',
  postCreateRefundRequest = 'postCreateRefundRequest',
  patchCancelRefundRequest = 'patchCancelRefundRequest',
  patchReactivateRefundRequest = 'patchReactivateRefundRequest',
}
